import { render, staticRenderFns } from "./UserPreview.vue?vue&type=template&id=2bfc1266&"
import script from "./UserPreview.vue?vue&type=script&lang=js&"
export * from "./UserPreview.vue?vue&type=script&lang=js&"
import style0 from "./UserPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports